import { render, staticRenderFns } from "./class-lesson.vue?vue&type=template&id=2daa50d1&scoped=true"
import script from "./class-lesson.vue?vue&type=script&lang=js"
export * from "./class-lesson.vue?vue&type=script&lang=js"
import style0 from "./class-lesson.vue?vue&type=style&index=0&id=2daa50d1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa50d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2daa50d1')) {
      api.createRecord('2daa50d1', component.options)
    } else {
      api.reload('2daa50d1', component.options)
    }
    module.hot.accept("./class-lesson.vue?vue&type=template&id=2daa50d1&scoped=true", function () {
      api.rerender('2daa50d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/class-lesson.vue"
export default component.exports